import React from 'react';
import { Calendar, Users, MapPin, Clock } from 'lucide-react';
import { RESERVATION_TYPES } from '../firebase/reservationService';

const SpecialConfirmation = ({ type, customerName, date, people }) => {
  const isWaitlist = type === RESERVATION_TYPES.WAITLIST;
  const title = isWaitlist ? 'Solicitud de Lista de Espera Recibida' : 'Solicitud de Grupo Recibida';
  
  return (
    <div className="max-w-xl mx-auto">
      <h2 className="text-2xl font-bold text-center mb-6">{title}</h2>
      
      <div className="bg-blue-50 p-4 rounded-lg mb-6">
        <p className="text-blue-800">
          {isWaitlist 
            ? 'Su solicitud para entrar en la lista de espera ha sido recibida. Le contactaremos en caso de que se libere una mesa en la fecha seleccionada.'
            : 'Su solicitud de reserva para grupo ha sido recibida. Nuestro equipo revisará su solicitud y se pondrá en contacto con usted en breve para confirmar los detalles.'}
        </p>
      </div>
      
      <p className="text-center">Gracias por elegir Low Country Boys Las Rozas</p>
    </div>
  );
};

export default SpecialConfirmation;